import _map from 'lodash/map';
import React, { Component } from 'react';
import { gql } from '@apollo/client';
import { Mutation } from '@apollo/react-components';
import { Button, Select } from 'antd';
import SpinnerError from '$components/library/SpinnerError';
import { STAFF_USER_DETAILS } from '../queries';
import styles from './styles.scss';

const STAFF_SUBSCRIBE_USER = gql`
  mutation StaffSubscribeUser($input: StaffSubscribeUserInput!) {
    staffSubscribeUser(input: $input) {
      subscription {
        uuid
        status
        expiresAt
        productUuid
      }
    }
  }
`;

class SubscribeButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProduct: props.products[0],
    };
  }

  selectProduct = (productUuid) => {
    const { products } = this.props;
    const product = products.find((p) => p.uuid === productUuid);
    this.setState({
      selectedProduct: product,
    });
  };

  render() {
    const { products, user } = this.props;
    const { selectedProduct } = this.state;

    if (!products || products.length === 0) {
      return null;
    }

    return (
      <Mutation
        mutation={STAFF_SUBSCRIBE_USER}
        refetchQueries={[
          {
            query: STAFF_USER_DETAILS,
            variables: { input: { uuid: user.uuid } },
          },
        ]}
      >
        {(
          staffSubscribeUser,
          {
            loading: staffSubscribeUserLoading,
            error: staffSubscribeError,
            data: staffSubscribeUserData,
          }
        ) => {
          if (staffSubscribeUserLoading || staffSubscribeError) {
            return <SpinnerError error={staffSubscribeError} />;
          }

          if (staffSubscribeUserData) {
            return null;
          }

          return (
            <div className={styles.layout}>
              <Select
                className={styles.select}
                defaultValue={products[0].uuid}
                onChange={this.selectProduct}
              >
                {_map(products, (product) => {
                  return (
                    <Select.Option key={product.uuid} value={product.uuid}>
                      {product.name}
                    </Select.Option>
                  );
                })}
              </Select>
              <Button
                loading={staffSubscribeUserLoading}
                onClick={() =>
                  staffSubscribeUser({
                    variables: {
                      input: {
                        userUuid: user.uuid,
                        productUuid: selectedProduct.uuid,
                      },
                    },
                  })
                }
              >
                {' '}
                Subscribe{' '}
              </Button>
            </div>
          );
        }}
      </Mutation>
    );
  }
}

export default SubscribeButton;
